'use strict';

angular.module('dekky.forms.themes.bootstrap')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/bootstrap/fields/mountainAreaSelect.html',
		'<label for="{{ field.name + \'_region\' }}" ng-if="field.labelRegion">{{ field.labelRegion }}</label>' +
		'<select class="form-control" ng-model="field.selectedRegion" name="{{ field.name + \'_region\' }}" id="{{ field.name + \'_region\' }}" ng-options="item as item.name for item in field.items track by item.id" ng-change="field.changeRegion()"></select>' +
		'<label for="{{ field.name + \'_area\' }}" ng-if="field.labelArea">{{ field.labelArea }}</label>' +
		'<select class="form-control" ng-model="model" name="{{ field.name + \'_area\' }}" id="{{ field.name + \'_area\' }}" ng-options="item as item.name for item in field.mountainAreas track by item.id"></select>'
	);
});